import { Pipe, PipeTransform } from '@angular/core';

type Unit = 'second' | 'minute' | 'hour' | 'day' | 'week' | 'month' | 'year';

@Pipe({
  name: 'ssTimeago',
  standalone: true,
  pure: false,
})
export class SsTimeagoPipe implements PipeTransform {
  private rtf = new Intl.RelativeTimeFormat('pt-BR', { numeric: 'auto' });

  transform(value: any): string {
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) return '';

    const now = Date.now();
    const diffMs = date.getTime() - now;
    const diffSec = Math.round(diffMs / 1000);
    const abs = Math.abs(diffSec);

    const { unit, amount } = this.toUnit(abs);

    // diffSec < 0 => passado => amount negativo => "há X"
    const signed = diffSec < 0 ? -amount : amount;
    return this.rtf.format(signed, unit);
  }

  private toUnit(absSeconds: number): { unit: Unit; amount: number } {
    if (absSeconds < 60) return { unit: 'second', amount: absSeconds };

    const minutes = Math.round(absSeconds / 60);
    if (minutes < 60) return { unit: 'minute', amount: minutes };

    const hours = Math.round(minutes / 60);
    if (hours < 24) return { unit: 'hour', amount: hours };

    const days = Math.round(hours / 24);
    if (days < 7) return { unit: 'day', amount: days };

    const weeks = Math.round(days / 7);
    if (weeks < 4) return { unit: 'week', amount: weeks };

    const months = Math.round(days / 30);
    if (months < 12) return { unit: 'month', amount: months };

    const years = Math.round(days / 365);
    return { unit: 'year', amount: years };
  }
}

